import { render } from "./designListShowPreview.vue?vue&type=template&id=ca54755e"
import script from "./designListShowPreview.vue?vue&type=script&lang=js"
export * from "./designListShowPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__